import {useGlobalStore} from "@/store/useGlobalStore";
import payloadBuilder from "@/utilities/payload-builder";
import {decryptData} from "@/utilities/crypto";
import router from "@/router";
import {useAuthStore} from "@/store/useAuthStore";

export default function transactionRequests() {
    const globalStore = useGlobalStore()
    async function getGLAccounts() {
        globalStore.glAccounts = []
        return []
    }

    async function getSLAccounts() {
        let data = []
        const responseList = await payloadBuilder('entities', 'list')
            .addPayload('conditions', {params: {type: 'payor_list'}}).execute();
        if(responseList){
            let data = responseList.data.data
            data = data.map(datum => {
                const isDisabled = datum.status === 0
                return {
                    ...datum,
                    disabled: isDisabled
                }
            })
            globalStore.slAccounts = data
        }
        return data
    }

    async function getBranches(all = true, store = true, returnOptions = false) {
        let data = []
        const conditions = { type: 'branches' }
        const responseList = await payloadBuilder('setup', 'list').addPayload('conditions', {
            params: conditions
        }).execute();
        if(responseList){
            let allList = responseList.data.data
            let data = responseList.data.data
            let assigned_branch = []

            // get branches tagged to user to set for disabling of options
            if(localStorage.getItem('branches')) {
                assigned_branch = decryptData(localStorage.getItem('branches'))
                if(assigned_branch) {
                    assigned_branch = JSON.parse(assigned_branch) ?? []
                    globalStore.assigned_branch = assigned_branch
                }
            }

            data = data.map(datum => {
                let isDisabled = datum.status === 0
                // for limiting of branch to list (based on user tagged branch)
                if(!all) isDisabled = isDisabled || !assigned_branch.includes(datum.code)
                return {
                    ...datum,
                    disabled: isDisabled
                }
            })

            // check if to add in globalStore
            // as there might be cases where globalStore.branches should not be updated
            if(store) globalStore.branches = data
            useAuthStore().updateLoggedUserDefaultBranch()
            // this is being queried every route change,
            // so if there's a current branch in local storage, no need to update the default branch
            if(localStorage.getItem('current_branch')) globalStore.default_branch = decryptData(localStorage.getItem('current_branch'))

            if(returnOptions) {
                // returnOptions is for options that needs to response all branches,
                // and limiting branches where user is tagged
                globalStore.all_branches = allList

                return {
                    all: allList,
                    restricted: data
                }
            }
            return data
        }
        return data
    }

    async function getEntities() {
        globalStore.entities = []
        return []
    }

    async function getItemCategories(level) {
        try {
            let data = []
            const conditions = { type: 'item_category', conditions: {level: level}}
            const responseList = await payloadBuilder('setup', 'list').addPayload('conditions', {
                params: conditions
            }).execute();
            if(responseList){
                let data = responseList.data.data
                data = data.map(datum => {
                    const isDisabled = datum.status === 0
                    return {
                        ...datum,
                        disabled: isDisabled
                    }
                })
                globalStore.categories = data
            }
            return data
        } catch (error) {
            return []
        }
    }

    async function getBranchTransactionSetup() {
        const responseList = await payloadBuilder('setup', 'list').addPayload('conditions', {
            params: { type: 'branch_transaction' }
        }).execute();
        if(responseList){
            let data = responseList.data.data
            globalStore.mode_of_payment = data.mode_of_payment
            globalStore.transaction_purpose = data.purpose
        }
    }

    async function getItemUnits() {
        try {
            const responseList = await payloadBuilder('setup', 'list').addPayload('conditions', {
                params: { type: 'units' }
            }).execute();
            if(responseList){
                let data = responseList.data.data
                data = data.map(datum => {
                    const isDisabled = datum.status === 0
                    return {
                        ...datum,
                        disabled: isDisabled
                    }
                })
                globalStore.item_units = data
            }
        } catch (error) {
            return []
        }
    }

    async function getSystemConfiguration() {
        try {
            const SYSTEM = process.env.VUE_APP_SYSTEM
            const responseList = await payloadBuilder('sysconfig', 'get', 'guest').addPayload('conditions', {
                 system: SYSTEM ?? 'system_code'
            }).execute();
            if(responseList){
                if(responseList.data.statusCode) {
                    return await router.push({name: 'errorPage'})
                }
                let data = responseList.data.data

                localStorage.setItem('sys_config', JSON.stringify(data))
                globalStore.sys_configs = data

                let icon = document.getElementById('sys_icon')
                if(icon) icon.setAttribute('href', data?.['SYS_LOGO'] ?? process.env.VUE_APP_SYSTEM_LOGO)

                document.querySelector('#sys_title').textContent = (data?.['SYS_BRAND'] + ' ' + data?.['SYS_TYPE'])
                    ?? (process.env.VUE_APP_SYSTEM_BRAND + ' ' + process.env.VUE_APP_SYSTEM_NAME)
                return data
            }
        } catch (error) {
            console.error(error)
            await router.push({name: 'errorPage'})
            return []
        }
    }

    return {
        getGLAccounts,
        getSLAccounts,
        getBranches,
        getEntities,
        getItemCategories,
        getBranchTransactionSetup,
        getItemUnits,
        getSystemConfiguration
    }
}